import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { VisibaApiHttp } from '../Classes/visibaHttp.class';
import { AppointmentAccessApiModel } from './Models/General/AppointmentAccessApiModel';
import { AppointmentCalendarInfoApiModel } from './Models/General/AppointmentCalendarInfoApiModel';
import { PhoneVerificationApiModel } from './Models/General/PhoneVerificationApiModel';
import { CompletePhoneVerificationApiModel } from './Models/General/CompletePhoneVerificationApiModel';
import { environment } from 'Public_old/src/environments/environment';
import { RRSessionApiModel } from './Models/General/RRSessionApiModel';

@Injectable()
export class GeneralService {
	constructor(private http2: HttpClient, private http: VisibaApiHttp) {}

	setlanguage(languageCode: string) {
		return this.http.put('/Api/General/Language/SetLanguage', { LanguageCode: languageCode });
	}

	signOut() {
		localStorage.removeItem('identitySession');
		return this.http2.get('/Api/General/Identity/signOut');
	}

	getAppointmentAccessInfo(callTicket: string) {
		return this.http.getTyped<AppointmentAccessApiModel>(`/Api/General/Appointment/${callTicket}/accessInfo`);
	}

	getAppointmentCalendarInfo(callTicket: string) {
		return this.http.getTyped<AppointmentCalendarInfoApiModel>(`/Api/General/Appointment/${callTicket}/calendarInfo`);
	}

	public getRRSessionId(bookingId: number) {
		return this.http.getTyped<RRSessionApiModel>(`/Api/General/Appointment/${bookingId}/redRobinSession`);
	}

	touchSession() {
		return this.http2.get(`${environment.api.uri}/Api/General/Session/touch`);
	}

	verifyPhoneNumber(licenceHolderId: number, phoneNumber: string, countryCode: string, languageCode: string) {
		return this.http.postTyped<PhoneVerificationApiModel>(
			`/api/General/LicenceHolders/${licenceHolderId}/VerificationAttempts/Phone`,
			{
				PhoneNumber: phoneNumber,
				CountryCode: countryCode,
				LanguageCode: languageCode,
			},
		);
	}

	completePhoneNumberVerification(licenceHolderId: number, verificationAttemptId: string, verificationCode: string) {
		return this.http.putTyped<CompletePhoneVerificationApiModel>(
			`/api/General/LicenceHolders/${licenceHolderId}/VerificationAttempts/${verificationAttemptId}`,
			{
				VerificationCode: verificationCode,
			},
		);
	}
}
